import React, {PureComponent} from 'react';
import PropTypes from "prop-types";

//This is a select component utilizing an input tag

class FormDropdown extends PureComponent{
    state={
        listOpen: false
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    handleClickOutside(event) {
        if (this.node && !this.node.contains(event.target)) {
           this.setState({listOpen: false});
        }
    }

    toggleDropdown = e => {
        e.stopPropagation();
        this.setState(prevState => ({ listOpen: !prevState.listOpen }));
    };

    handleOptionClick(value){
        this.setState({listOpen: false});
        this.props.onChange(this.props.name, value);
    }

    render(){
        return (
            <div ref={n => this.node = n} className="dropdown-input">
                <input 
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onClick={this.toggleDropdown.bind(this)}
                    type="text"
                    readOnly
                />
                {this.state.listOpen && <div className="dropdown">
                    {this.props.list.map((v, i)=>{
                        let classes = `dropdown-option ${v === this.props.value ? 'dropdown-selected' : ''}`
                        return <div className={classes} key={i} onClick={ e => this.handleOptionClick(v)}>{v}</div>
                    })}
                </div>}
            </div>
        );
    }
}

FormDropdown.propTypes = {
    list: PropTypes.array.isRequired,
    title: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string,PropTypes.number])
}

export default FormDropdown;